module.exports = __webpack_public_path__ + "img/sol2.5e846314.png";